import { apiClient } from '@/sdk/shared/apiClient';
import type { DownloadsListResponse } from './types';

export const clientDownloadsApi = {
  /**
   * Fetch all application downloads for the tenant
   */
  getDownloads: async (): Promise<DownloadsListResponse> => {
    return await apiClient.get<DownloadsListResponse>('/client/downloads');
  }
};

export default clientDownloadsApi;
